<template>
  <div class="post-re-comment">
    <div class="recomments-wrap" v-for="item in reComments" >
      <div class="recomments-info" v-if="showComments">
        <img class="post-comment__user-icon" :src="item.author_logo">
        <div class="post-comment__body">
          <div class="post-comment__user-name">{{item.author}}</div>
          <div class="post-comment__text" v-html="reCommentText(item.text)"></div>
          <div class="post-comment__images" v-if="item.images.length">
            <img class="post-comment__image" v-for="image in item.images" :src="image" width="200px">
          </div>
        </div>
      </div>
    </div>
    <div class="post-comment__date ">
      {{ moment(comment.created_date).format('HH:mm DD.MM.YYYY') }}
    </div>
    <div class="button-wrap">
      <button class="show-more-comment" v-if="showMoreButton && showComments" @click.stop="getReComments">
        Показать еще
      </button>
      <!--<span class="post-comments-count__show" @click="showComments = !showComments">
            {{showComments ? 'Скрыть' : 'Показать комментарии'}}
      </span>-->
    </div>

    <template v-for="item in reComments">
      <post-re-comment v-if="parseInt(item.children) > 0" :comment="item"/>
    </template>

  </div>
</template>

<script>
import PostComment from '../../components/posts/postComment.vue';
import { getReCommentsApi } from '../../../../api/posts';
import moment from 'moment/moment';

export default {
  name: 'postReComment',
  props: {
    comment: {
      type: Object
    }
  },
  components: { PostComment },
  data() {
    return {
      moment,
      regex: /\[(.*?)\]/g,
      reqPending: false,
      limit: 30,
      start: 0,
      showMoreButton: true,
      showComments: true,
      count: 0,
      reComments: [],
      social: {
        '1': {
          domen: 'https://vk.com/',
        },
        '3': {
          domen: 'https://www.facebook.com/',
        },
        '2': {
          domen: 'https://twitter.com/',
        },
      },
    };
  },
  methods: {
    replaceByNetwork(text) {
      const matches = text.match(this.regex);

      if (matches) {
        const matchedValues = matches.map(match => match.replace('[', this.social[this.comment.network_id].domen).replace(']', '')).join(' ');
        const matchedArray = matchedValues.split('|');
        const link = `<a href="${matchedArray[0]}" target="_blank">${matchedArray[1]}</a>`;
        return text.replace(matches[0], link);
      }

      return text;
    },
    reCommentText(text) {
      return this.replaceByNetwork(text);
    },
    getReComments() {
      this.reqPending = true;
      const params = {
        limit: this.limit,
        network_id: this.comment.network_id,
        owner_id: this.comment.owner_id,
        post_id: this.comment.post_id,
        comment_id: this.comment.id,
        start: this.start,
        thread_id: this.$route.params.id
      };

      getReCommentsApi(params)
        .then((resp) => {
          this.reComments = [...this.reComments, ...resp.data.commentaries];
          this.count = this.reComments.length ? this.reComments.length : 0;

          if (this.count < this.limit || this.count === parseInt(resp.data.count, 10)) {
            this.showMoreButton = false;
          }

          this.start = this.reComments.length;
          this.reqPending = false;
        })
        .catch((err) => {
          this.reqPending = false;
          return err;
        });
    },
  },
  mounted() {
    this.getReComments();
  }
};
</script>

<style lang="stylus" scoped>
.post-re-comment
  padding 0 0 0 3em
  &:first-child
    margin-top 1em
  .post-comment__user-icon
    width 2em
    height 2em
    margin-right .6em
    margin-left .6em
.recomments-wrap {
  display flex
  flex-direction column
  padding 5px 0 14px 0
}
.recomments-info {
  display flex
}

.button-wrap
  width 100%
  padding 5px 15px 5px 0
  display flex
  align-items center
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  text-decoration none
  box-sizing border-box

.post-comments-count__show
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  color #55626F
  cursor pointer
.show-more-comment
  margin-right 20px
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  border none
  outline none
  background-color transparent
  color #55626F
  cursor pointer

.post-comment__images {
  position relative
  display flex
  flex-wrap wrap
  align-items center
}

.post-comment__image {
  width 250px
  margin-right 5px
  margin-bottom 5px;
}

.post-comment__image:last-child {
  margin 0
}
</style>
